import type { ScanImagesView } from './scanPreviewState.ts';

// How many images a set holds, as far as is known: 'none' is iTero's 204, 'unknown' a 202 or error.
export type ImageTally =
    { kind: 'pending' } | { kind: 'unknown' } | { kind: 'none' } | { kind: 'count'; count: number };

export function imageTally<TImage>(view: ScanImagesView<TImage>): ImageTally {
    switch (view.status) {
        case 'loading':
            return { kind: 'pending' };
        case 'ready':
            return { kind: 'count', count: view.images.length };
        case 'empty':
            return { kind: 'none' };
        case 'generating':
        case 'error':
            return { kind: 'unknown' };
    }
}

export function tallyCount(tally: ImageTally): number | null {
    if (tally.kind === 'count') return tally.count;
    return tally.kind === 'none' ? 0 : null;
}

// Shown only once every set has settled, so the number never counts up while images arrive.
export function scansCountLabel(tallies: readonly ImageTally[]): string | null {
    if (tallies.some((tally) => tally.kind === 'pending')) return null;
    const counts = tallies.map(tallyCount).filter((count): count is number => count !== null);
    if (counts.length === 0) return null;
    return counts.reduce((sum, count) => sum + count, 0).toLocaleString('en-US');
}
